import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import {
  UserDetailsProvider,
  useUserDetails,
} from "./Dashboard/UserDetailsContext.js";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import ExpenseApproval from "./Admin/ExpenseApproval.jsx";
import AdminDashboard from "./Admin/AdminDashboard.jsx";
import ExpenseManager from "./Expense/ExpenseManager.jsx";
import ManageCategories from "./Admin/ManageCategories.jsx";
import ExpenseForm from "./Expense/ExpenseForm.jsx";
import { ThemeProvider } from "./ThemeContext";
import ThemeToggle from "./components/ThemeToggle";
import "./App.css";
import SignIn from "./Admin/SignIn";
import React, { useEffect } from 'react';

// Dynamically import the theme CSS based on environment
const theme = window.env.REACT_APP_THEME;
console.log("Curr theme:", theme);
import(`./StyleSheet/${theme}.css`)
  .then(() => console.log(`${theme} theme applied`))
  .catch((err) => console.error("Error loading theme:", err));

function AppContent() {
   const { userDetails, isLoading } = useUserDetails();

  useEffect(() => {
    if (!isLoading && (!userDetails || !userDetails.UserRole)) {
      window.location.href = 'https://accounts.aurumi.ai';
    }
  }, [userDetails, isLoading]);

  // if (isLoading) return <div>Loading...</div>;

  // If user details are not available, return null (the useEffect will handle redirection)
  if (!userDetails || !userDetails.UserRole) {
    return null;
  }

  const role = userDetails.UserRole.toLowerCase();

  return (
    <ThemeProvider>
    {/* <ThemeToggle/> */}
    <Routes>
      <Route
        path="/"
        element={
          role === "owner" ? <AdminDashboard /> : <AdminDashboard />
        }
      />
      {/* <Route path="/" element={<AdminDashboard></AdminDashboard>}/>
      <Route path="/expenses" element={<ExpenseManager></ExpenseManager>}/> */}
      <Route path="/manage-categories" element={<ManageCategories />} />
      <Route path="/signin" element={<SignIn />} />
      <Route
        path="/approve"
        element={
         <ExpenseApproval /> 
        }
      />
      {/* Catch-all route if user navigates to an unknown path */}
      <Route path="*" element={<Navigate to="/" replace />} />
      
      <Route path="/expenseform" element={<ExpenseForm></ExpenseForm>}/>
    </Routes>
    </ThemeProvider>

  );
  
}

function App() {
  return (
    <Router>
      <UserDetailsProvider>
        <AppContent />
        <ToastContainer />
      </UserDetailsProvider>
    </Router>
    
  );
  
}

export default App;
